import { httpClient as http } from '@/utils/http'
import type {
  PageResponse,
  SurchargePrePortPageRequest,
  SurchargePrePortVO,
  SurchargeChangeLogQueryRequest,
  SurchargeChangeLog
} from './types'

// 分页查询港前附加费
export const page = (params: SurchargePrePortPageRequest) =>
  http.post<PageResponse<SurchargePrePortVO>>('/price/surcharge/pre-port/page', params)

// 新增港前附加费
export const save = (params: SurchargePrePortVO) =>
  http.post<boolean>('/price/surcharge/pre-port/save', params)

// 修改港前附加费
export const update = (params: SurchargePrePortVO) =>
  http.post<boolean>('/price/surcharge/pre-port/update', params)

// 详情
export const get = (id: number) =>
  http.post<SurchargePrePortVO>('/price/surcharge/pre-port/get', { id })

// 删除
export const deleteById = (id: number) =>
  http.post<boolean>('/price/surcharge/pre-port/delete', { id })

// 批量启用
export const batchOnline = (params: { ids: number[] }) =>
  http.post<boolean>('/price/surcharge/pre-port/batch-online', params)

// 批量停用
export const batchOffline = (params: { ids: number[] }) =>
  http.post<boolean>('/price/surcharge/pre-port/batch-offline', params)

// 查询冲突候选港前附加费
export const queryConflictCandidates = (params: SurchargePrePortVO) =>
  http.post<SurchargePrePortVO[]>('/price/surcharge/pre-port/queryConflictCandidates', params)

// 变更历史
export const changeLog = (params: SurchargeChangeLogQueryRequest) =>
  http.post<PageResponse<SurchargeChangeLog>>('/price/surcharge/pre-port/change-log', params)
